import { useContext } from 'react';
import { ChatContext } from '../contexts/ChatContext';
import { Area } from './useChatOperations';

// Define the return type of useChat with proper typing for areas
interface ChatContextType {
  homeId: string;
  messages: any[];
  isLoading: boolean;
  isLoadingMessages: boolean;
  areas: Area[];
  sendMessage: (message: string) => Promise<void>;
  refreshMessages: () => Promise<void>;
  
  // Add the missing properties
  completedTaskIds: Set<string>;
  toggleTaskCompletion: (taskId: string) => void;
  getActiveTaskCount: () => number;
  homePrimaryImage: string | null;
  lastUpdated: number;
}

export const useChat = (): ChatContextType => {
  const context = useContext(ChatContext);
  if (context === undefined) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context as ChatContextType;
};